export const FETCH_DRIVER_STANDINGS_REQUEST = "FETCH_DRIVER_STANDINGS_REQUEST";
export const FETCH_DRIVER_STANDINGS_SUCCESS = "FETCH_DRIVER_STANDINGS_SUCCESS";
export const FETCH_DRIVER_STANDINGS_FAILURE = "FETCH_DRIVER_STANDINGS_FAILURE";